import styled from 'styled-components'

// Etichetta + campo in colonna con gap fisso (alternativa a FormGroup, che usa margin-bottom)
export const FormGroupStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`
